import { render, staticRenderFns } from "./service-program-card.vue?vue&type=template&id=b4ebbd48&scoped=true&"
import script from "./service-program-card.vue?vue&type=script&lang=js&"
export * from "./service-program-card.vue?vue&type=script&lang=js&"
import style0 from "./service-program-card.vue?vue&type=style&index=0&id=b4ebbd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ebbd48",
  null
  
)

export default component.exports